/// <amd-module name="Build/Admin/Pool/Components/MaintenanceHistoryContainer" />
import * as React from "react";

import { VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";

import { Card } from "VSSUI/Card";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { ZeroData, ZeroDataActionType } from "VSSUI/ZeroData";

import { TaskAgentPoolMaintenanceJob } from "DistributedTask/Client/Contracts/TaskAgent";

import { PoolHubViewKeys, Assets, StoreStatus } from "Build/Admin/Common/Constants";
import { SignalRState } from "Build/Admin/Common/Stores/SignalRStore";
import { PoolActionCreator } from "Build/Admin/Pool/Actions/PoolActionCreator";
import { MaintenanceJobsList } from "Build/Admin/Pool/Components/MaintenanceJobsList";
import { StoresHub } from "Build/Admin/Pool/Stores/StoresHub";

import * as Resources from "Build/Admin/Pool/Resources";

export interface IMaintenanceHistoryContainerProps {
    actionCreator: PoolActionCreator;
    storesHub: StoresHub;
}

export interface IMaintenanceHistoryContainerState {
    jobs: TaskAgentPoolMaintenanceJob[];
    signalRState: SignalRState;
    renderZeroData: boolean;
}

const LargeSpinner = () => <Spinner className="pipelines-pool-maintenance-spinner scroll-hidden flex-grow flex-self-center" size={SpinnerSize.large} />;

export class MaintenanceHistoryContainer extends VssComponent<IMaintenanceHistoryContainerProps, IMaintenanceHistoryContainerState> {
    constructor(props: IMaintenanceHistoryContainerProps) {
        super(props);
        this.state = this._getStateFromStores();
    }

    public componentDidMount(): void {
        this.props.storesHub.selectionStore.addChangedListener(this._onChanged);
        this.props.storesHub.maintenanceJobStore.addChangedListener(this._onChanged);
        this.props.storesHub.signalRStore.addChangedListener(this._onChanged);
    }

    public componentWillUnmount(): void {
        this.props.storesHub.selectionStore.removeChangedListener(this._onChanged);
        this.props.storesHub.maintenanceJobStore.removeChangedListener(this._onChanged);
        this.props.storesHub.signalRStore.removeChangedListener(this._onChanged);
    }

    public render(): JSX.Element {
        return (
            <div className="pipelines-pool-jobs page-content page-content-top">
            {
                this.state.renderZeroData &&
                <ZeroData
                    primaryText={Resources.ZeroMaintenanceJobsPrimaryText}
                    secondaryText={Resources.ZeroMaintenanceJobsSecondaryText}
                    actionText={Resources.Settings}
                    actionType={ZeroDataActionType.ctaButton}
                    onActionClick={() => this.props.actionCreator.updateSelectedTab(PoolHubViewKeys.Settings)}
                    imagePath={getAssetLocation(this.context.pageContext, Assets.ZeroDataPng)}
                    imageAltText="" />
            }
            {
                !this.state.renderZeroData &&
                <Card className="flex-grow bolt-card-no-vertical-padding" contentProps={{ contentPadding: false }}>
                    {
                        this.props.storesHub.maintenanceJobStore.state.status === StoreStatus.Loaded &&
                        <MaintenanceJobsList
                            jobs={this.state.jobs}
                            signalRState={this.state.signalRState}
                        />
                    }
                    {
                        this.props.storesHub.maintenanceJobStore.state.status !== StoreStatus.Loaded &&
                        <LargeSpinner />
                    }
                </Card>
            }
            </div>
        );
    }

    private _onChanged = (): void => {
        this.setState(this._getStateFromStores());
    }

    private _getStateFromStores(): IMaintenanceHistoryContainerState {
        return {
            jobs: this.props.storesHub.maintenanceJobStore.state.jobs,
            signalRState: this.props.storesHub.signalRStore.state,
            renderZeroData: this.props.storesHub.maintenanceJobStore.state.jobs.length === 0
        };
    }
}
